import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 21"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m9.167 11.404.7 1.823c1.056 2.743 1.583 4.115 2.291 4.46a2 2 0 0 0 1.917-.09c.673-.41 1.069-1.826 1.861-4.655l1.697-6.06c.501-1.791.752-2.687.52-3.301a2 2 0 0 0-1.163-1.162c-.614-.233-1.51.018-3.301.52l-6.06 1.696c-2.83.792-4.244 1.188-4.654 1.86a2 2 0 0 0-.09 1.917c.344.709 1.716 1.236 4.458 2.291l1.824.701Zm0 0 2.083-2.083"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 .571h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
